module.exports = __webpack_public_path__ + "static/media/mastercard.b1393bee.png";